import { render } from "./SedeTab.vue?vue&type=template&id=184b5ae6"
import script from "./SedeTab.vue?vue&type=script&lang=js"
export * from "./SedeTab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__